import __request__ from "routing/request";
export function getAll(requestOptions) {
  return __request__("GET", "/system/indexer/indices/templates", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function syncAll(requestOptions) {
  return __request__("POST", "/system/indexer/indices/templates/update", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(indexSetId, requestOptions) {
  return __request__("GET", `/system/indexer/indices/templates/${indexSetId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function sync(indexSetId, requestOptions) {
  return __request__("POST", `/system/indexer/indices/templates/${indexSetId}/update`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
